import dayjs, { Dayjs } from 'dayjs'

type DurationValidation = {
  duration: Dayjs | null
  error: string | null
}

const validateDuration = (time: Dayjs | null): DurationValidation => {
  if (!time || !time.isValid() || (time.hour() * 60 + time.minute()) < 5) {
    return { duration: time, error: 'Deve ser igual ou superior a 00:05' }
  }
  if (time.hour() === 23 && time.minute() >= 59) {
    return { duration: dayjs().hour(23).minute(59), error: 'Deve ser igual ou inferior a 23:59' }
  }
  return { duration: time, error: null }
}

export default validateDuration
